import React from 'react';
import { ICountry } from '../../interfaces';

export const DEFAULT_COUNTRY_OPTION = (
  <option key="US" value="US">
    United States
  </option>
);
export const SELECT_COUNTRY_OPTION = (
  <option key="" value="">
    Select Country
  </option>
);
export const SELECT_STATE_OPTION = (
  <option key="" value="">
    Select State
  </option>
);

const buildCountriesSelect = (countries: ICountry[]): JSX.Element[] => {
  if (!countries.length) {
    return [SELECT_COUNTRY_OPTION, DEFAULT_COUNTRY_OPTION];
  }
  const countriesSelect = countries.map((country) => {
    const { countryCode, displayName } = country;
    return (
      <option key={countryCode} value={countryCode}>
        {displayName}
      </option>
    );
  });
  countriesSelect.unshift(SELECT_COUNTRY_OPTION);
  return countriesSelect;
};

const buildStatesSelect = (
  countries: ICountry[],
  countryCode: string
): JSX.Element | JSX.Element[] => {
  const currentCountry = countries.find(
    (country) => country.countryCode.toLowerCase() === countryCode.toLowerCase()
  );
  if (!currentCountry) return <option key="no_state">Select State</option>;

  if (!currentCountry?.states) {
    return <option key="no_state">No State Required</option>;
  }

  const statesSelect = currentCountry.states.map((state) => {
    const { stateCode, displayName } = state;
    return (
      <option key={stateCode} value={stateCode}>
        {displayName}
      </option>
    );
  });

  statesSelect.unshift(SELECT_STATE_OPTION);
  return statesSelect;
};

const shouldSelectBeDisabled = (
  name: string,
  countries: ICountry[],
  currentCountryCode: string
): boolean => {
  if (name !== 'shipState') {
    return false;
  }
  if (!countries.length) {
    return true;
  }
  if (currentCountryCode === '') {
    return true;
  }
  const currentCountry = countries.find((c) => c.countryCode === currentCountryCode);
  if (currentCountry) {
    return !currentCountry.hasStates;
  }
  return false;
};

export { buildCountriesSelect, buildStatesSelect, shouldSelectBeDisabled };
